import { Button, Tag, message, Select } from '@maxtropy/components';
import { Popover, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Dayjs } from 'dayjs';
import { TimeRange } from '../types';
import { useState } from 'react';
import { validateTimeRangeDuplicate } from '../utils';
import dayjs from 'dayjs';

interface QueryTimeRangeSelectorProps {
  queryTimeRanges?: TimeRange[];
  showTimePicker: boolean;
  onAddTimeRange: ({ monitorStartTime, monitorEndTime }: { monitorStartTime: string; monitorEndTime: string }) => void;
  onRemoveTimeRange: (index: number) => void;
  onToggleTimePicker: (open: boolean) => void;
}

// 生成 0-24 小时选项
const hourOptions = Array.from({ length: 25 }, (_, i) => ({
  label: `${i.toString().padStart(2, '0')}:00`,
  value: i,
}));

const QueryTimeRangeSelector = ({
  queryTimeRanges,
  showTimePicker,
  onAddTimeRange,
  onRemoveTimeRange,
  onToggleTimePicker,
}: QueryTimeRangeSelectorProps) => {
  const [startHour, setStartHour] = useState<number | null>(null);
  const [endHour, setEndHour] = useState<number | null>(null);

  const handleAddTimeRange = () => {
    if (startHour === null || endHour === null) {
      message.warning('请选择开始和结束时间');
      return;
    }
    if (startHour >= endHour) {
      message.error('结束时间必须大于开始时间');
      return;
    }

    const startTime = dayjs().hour(startHour).minute(0).second(0);
    const endTime = dayjs().hour(endHour).minute(0).second(0);
    const newRange: [Dayjs, Dayjs] = [startTime, endTime];
    console.log('startTime', startTime, endTime);

    const newRangeObj = {
      monitorStartTime: startTime.format('HH:00'),
      monitorEndTime: endHour === 24 ? '24:00' : endTime.format('HH:00'),
    };
    if (validateTimeRangeDuplicate(newRangeObj, queryTimeRanges!)) {
      onAddTimeRange?.(newRangeObj);
      console.log('newRangeObj', newRangeObj, newRange);
      setStartHour(null);
      setEndHour(null);
      onToggleTimePicker(false);
    } else {
      message.error('有重复时段，请重新选择');
    }
  };

  const handleReset = () => {
    setStartHour(null);
    setEndHour(null);
  };

  return (
    <Space size={8}>
      <Popover
        open={showTimePicker}
        onOpenChange={open => {
          if (!open) {
            handleReset();
          }
          onToggleTimePicker(open);
        }}
        trigger="click"
        placement="bottomLeft"
        content={
          <div style={{ padding: 12 }}>
            <Space direction="vertical" size={10}>
              <Space size={4}>
                <Select
                  style={{ width: 100 }}
                  options={hourOptions}
                  value={startHour}
                  onChange={setStartHour}
                  placeholder="开始时间"
                />
                <span style={{ color: 'var(--mx-text-secondary-color)' }}>至</span>
                <Select
                  style={{ width: 100 }}
                  options={hourOptions}
                  value={endHour}
                  onChange={setEndHour}
                  placeholder="结束时间"
                />
              </Space>
              <Space style={{ justifyContent: 'flex-end', width: '100%' }}>
                <Button size="small" type="primary" onClick={handleAddTimeRange}>
                  确定
                </Button>
              </Space>
            </Space>
          </div>
        }
      >
        <Button type="dashed" icon={<PlusOutlined />} size="small" />
      </Popover>
      {queryTimeRanges?.map((range, index) => (
        <Tag
          key={`${range.monitorStartTime}-${range.monitorEndTime}`}
          closable={true}
          onClose={() => onRemoveTimeRange(index)}
        >
          {range.monitorStartTime}-{range.monitorEndTime}
        </Tag>
      ))}
    </Space>
  );
};

export default QueryTimeRangeSelector;
